
class AlgoliaService {
    public isAlgoliaSearch(): boolean {
        return !!this.getAlgoliaQueryId();
    }

    public getAlgoliaQueryId(): string {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('queryId') || '';
    }
}

export const algoliaService = new AlgoliaService();